import Cookies from 'js-cookie';

/**
 * Stores a Perlgem CSRF token in the browser cookie used by cart RPC requests.
 *
 * @param token The CSRF token returned by Perlgem.
 */
const setPerlgemCSRFToken = (token: string | undefined): void => {
  document.cookie = `csrftoken=${token}; Path=/; Secure`;
};

async function fetchPerlgemCSRFToken(): Promise<string | undefined> {
  const body = new URLSearchParams();
  body.append(
    'JSONRPC',
    JSON.stringify([
      {
        method: 'csrf.getToken',
        params: [{}]
      }
    ])
  );

  const response = await fetch(`/rpc/jsonrpc.tmpl?dbgmethod=csrf.getToken`, {
    method: 'POST',
    body
  });

  if (response.status !== 200) {
    return '';
  }

  const responseObj = await response.json();

  return responseObj[0]?.result?.value?.token;
}

async function getPerlgemCSRFToken(): Promise<string | undefined> {
  let token = Cookies.get('csrftoken');

  if (token === undefined) {
    token = await fetchPerlgemCSRFToken();
  }

  return token;
}

export default getPerlgemCSRFToken;
export { setPerlgemCSRFToken };
